import * as React from "react";

const EyeFilterColumns = (props: any) => (
  <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
    <g fillRule="nonzero">
      <path d="M11.5 5C6.951 5 2 11 2 11s4.51 6 9.5 6 9.5-6 9.5-6-4.952-6-9.5-6zm0 10.112c-2.203 0-3.99-1.84-3.99-4.112 0-2.272 1.787-4.112 3.99-4.112 2.203 0 3.99 1.84 3.99 4.112 0 2.272-1.787 4.112-3.99 4.112z" />
      <path d="M11.5 9a1.99 1.99 0 0 0-1.98 2c0 1.105.887 2 1.98 2a1.99 1.99 0 0 0 1.98-2c0-1.105-.887-2-1.98-2z" />
    </g>
  </svg>
);

export default EyeFilterColumns;

